'use strict';

const tooltip  = require('helpers/tooltip');
const loader = require('helpers/loader');

module.exports = Backbone.View.extend({
    events: function() {
        return {
            'click .js-pagination-next': 'loadNextPage',
            'click .js-pagination-prev': 'loadPrevPage',
            'click .js-pagination-page': 'loadPage',
            'click [data-sort]':         'actionSort',
            'change .js-searchbox':      'search',
            'keyup .js-searchbox':       'autoSubmitSearch'
        };
    },

    render: function() {
        tooltip.init(this);
        return this;
    },

    loadNextPage: function(ev) {
        let $button;
        let stopLoader;
        const load = () => {
            stopLoader = loader.startFullScreen($button);
            this.collection.nextPage({validate: false}).finally(stopLoader);
        };

        if (ev) {
            ev.preventDefault();
            $button = this.$(ev.currentTarget);
        }

        if (typeof this.beforePageChange === 'function') {
            this.beforePageChange()
                .then(load, () => { /* ignore */});
            return this;
        }
        load();
        return this;
    },

    loadPrevPage: function(ev) {
        let $button;
        let stopLoader;
        const load = () => {
            stopLoader = loader.startFullScreen($button);
            this.collection.prevPage({validate: false}).finally(stopLoader);
        };

        if (ev) {
            ev.preventDefault();
            $button = this.$(ev.currentTarget);
        }
        if (typeof this.beforePageChange === 'function') {
            this.beforePageChange()
                .then(load, () => { /* ignore */});
            return this;
        }
        load();

        return this;
    },

    loadPage: function(ev) {
        let $button;
        let stopLoader;
        let page;
        const load = () => {
            stopLoader = loader.startFullScreen($button);
            this.collection.fetchPage(page, {validate: false})
                .finally(stopLoader);
        };

        if (!ev) {
            return;
        }

        $button = this.$(ev.currentTarget);
        page = $button.data('page');

        if (typeof this.beforePageChange === 'function') {
            this.beforePageChange()
                .then(load, () => { /* ignore */});
            return this;
        }
        load();

        return this;
    },

    actionSort: function(ev) {
        const sortKey = $(ev.currentTarget).attr('data-sort');
        const sortOrder = this.collection.getSort().order === 'ascending' ?
            'descending' : 'ascending';

        this.collection.setOptions({sortKey, sortOrder});

        this.navigate();
        return false;
    },

    autoSubmitSearch: function(ev) {
        var val = (this.$(ev.currentTarget).val() || '').trim();

        if (!_.isUndefined(this.searchboxTimeout)) {
            clearTimeout(this.searchboxTimeout);
        }

        if (
            (this.collection.getSearchTerm() && val !==
            this.collection.getSearchTerm()) &&
            val.length >= 3
        ) {
            this.searchboxTimeout = setTimeout(() => {
                this.$(ev.currentTarget).trigger('change');
            }, 1500);
        }
    },

    search: function(ev) {
        var $el = this.$(ev.currentTarget);
        var value = encodeURIComponent($el.val() || '').trim();

        if (!_.isUndefined(this.searchboxTimeout)) {
            clearTimeout(this.searchboxTimeout);
        }

        $el.prop({'disabled': true});
        this.collection.searchString = value;
        this.navigate();
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/PaginatedList.js